'use client'

import { usePathname } from 'next/navigation'
import { useRouter } from 'nextjs-toploader/app'
import { Icon } from 'shared/iconpack'
import { DEFAULT_NEXT_HISTORY_LENGTh } from 'shared/model/const'

import { Button } from 'shared/ui/button'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

import styles from './HeaderCatalog.module.scss'

export function HeaderCatalog() {
  const pathName = usePathname()
  const router = useRouter()
  const isCategoryPage = pathName.startsWith(RouterPath.CATEGORY)

  const categoryMenu = () => {
    if (isCategoryPage) {
      const canGoBack = window.history.length > DEFAULT_NEXT_HISTORY_LENGTh
      canGoBack ? router.back() : router.push(RouterPath.HOME)
    } else {
      router.push(RouterPath.CATEGORY)
    }
  }

  return (
    <Button variant="accent" className={styles.button} onClick={categoryMenu}>
      <div className={styles.catalogButton}>
        <Icon name={isCategoryPage ? 'close' : 'burger'} size={24} />
        <p className="fw-500">Каталог</p>
      </div>
    </Button>
  )
}
